import type { ISession } from 'shared/lib/auth/types';

export const cachedPostRefresh = async (session: ISession) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_URL}/api/login/refresh`,
    {
      method: 'POST',
      // credentials: 'include',
      body: JSON.stringify(session),
      headers: { 'Content-Type': 'application/json' },
    }
  );

  if (!response.ok) {
    console.log('error refreshing token');
  }

  const updatedSession = await response.json();
  // console.log(
  //   'updated session from unstable cache: ',
  //   updatedSession.expires_at
  // );
  return updatedSession?.user.access_token;
};
